import type { MarketApp } from '@/features/dashboard/types';
import { MarketsComponents, MarketWidgetSkeleton, useMarketPreview } from '@/features/markets';
import { PageInformationContext } from '@/shared/lib/PageInformationContext';

export const Preview = ({
  template,
  enabled = true
}: {
  template: MarketApp | undefined;
  enabled?: boolean;
}) => {
  const { data, isFetching } = useMarketPreview(template ? [template] : undefined, enabled);
  return (
    <PageInformationContext value={{ mainPageTitle: 'Dashboard' }}>
      <div className='flex flex-1 flex-col bg-card p-4 [&_.apps__container]:flex [&_.apps__container]:flex-col [&_.apps__container]:gap-4 [&_.highlighted-prices__container]:flex-nowrap [&_.highlighted-prices__container]:flex-col [&_.highlighted-prices__container]:gap-4'>
        <h3 className={`label__container text-sm font-semibold ${enabled ? 'mb-2' : ''}`}>
          Preview
        </h3>

        {isFetching && (
          <div className='mt-2'>
            <MarketWidgetSkeleton />
          </div>
        )}
        {!isFetching && data && (
          <div className='pointer-events-none mt-2 select-none'>
            <MarketsComponents
              components={data.components}
              showAddToDashboard={false}
              showShareBlock={false}
            />
          </div>
        )}
      </div>
    </PageInformationContext>
  );
};
